import React from "react";
import { useTable, List, EditButton, ShowButton, CreateButton } from "@refinedev/antd";
import { Table, Space, Tag } from "antd";
import { USER_LIST_QUERY } from "./queries";

interface IUser {
  id: string;
  email: string;
  firstName?: string;
  lastName?: string;
  isActive: boolean;
  teamId?: string;
  appTeams?: {
    id: string;
    name: string;
  }[];
  organizationalRole?: string;
}

export const UserList: React.FC = () => {
  const { tableProps } = useTable<IUser>({
    resource: "users",
    initialPageSize: 10,
    meta: {
      gqlQuery: USER_LIST_QUERY,
    },
  });

  return (
    <List
      headerProps={{
        extra: (
          <Space>
            <CreateButton />
          </Space>
        ),
      }}
    >
      <Table {...tableProps} rowKey="id">
        <Table.Column dataIndex="email" title="Email" sorter />
        <Table.Column dataIndex="firstName" title="First Name" />
        <Table.Column dataIndex="lastName" title="Last Name" />
        <Table.Column dataIndex="teamId" title="Team ID" />
        <Table.Column
          title="App Teams"
          render={(_text: string, record: IUser) =>
            record.appTeams?.length ? record.appTeams.map(t => t.name).join(", ") : "-"
          }
        />
        <Table.Column dataIndex="organizationalRole" title="Organization Role" />
        <Table.Column
          dataIndex="isActive"
          title="Status"
          render={(isActive: boolean) => (
            <Tag color={isActive ? "green" : "red"}>
              {isActive ? "Active" : "Inactive"}
            </Tag>
          )}
        />
        <Table.Column
          title="Actions"
          dataIndex="actions"
          render={(_text: string, record: IUser) => (
            <Space>
              <ShowButton size="small" recordItemId={record.id} />
              <EditButton size="small" recordItemId={record.id} />
            </Space>
          )}
        />
      </Table>
    </List>
  );
};